import type React from "react"

interface AssessmentQuestionProps {
  text: string
  isAnimating: boolean
}

export const AssessmentQuestion: React.FC<AssessmentQuestionProps> = ({ text, isAnimating }) => {
  return (
    <div className={`transition-all duration-300 ${isAnimating ? "scale-95 opacity-0" : "scale-100 opacity-100"}`}>
      <div className="mb-8">
        <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-4 border border-teal-200">
          What feels right for you?
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-slate-900 leading-tight">{text}</h2>
      </div>
    </div>
  )
}
